<template>
    <div class="withdrawalList;padding:0 50px">
        <div style="width:100%;background-color:#fff;padding:10px">
            <span style="float:left;font-size:22px;margin-right:10px"> 提现列表</span>
            <el-input v-model="search" prefix-icon="el-icon-search" style="float:right;width:400px"></el-input>
        </div>
        <el-table :data=" tableData.filter(data => !search || data.username.toLowerCase().includes(search.toLowerCase())|| data.mobile.toLowerCase().includes(search.toLowerCase()))"
            style="width: 100%;margin-top:10px" height="1000px">
            <el-table-column prop="status" label="操作" width="200px" align="center">
                <template  slot-scope="scope">
                    <el-button @click="audit('agree',scope.row.id)" size="mini" style="float:left" :disabled="scope.row.status != 0">同意审核</el-button>
                    <el-button @click="audit('refuse',scope.row.id)" size="mini" style="float:left" :disabled="scope.row.status != 0">拒绝审核</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="u_id" label="ID" align="center"></el-table-column>
            <el-table-column prop="username" label="名称" align="center"></el-table-column>
            <el-table-column prop="mobile" label="联系方式" align="center"></el-table-column>
            <el-table-column label="提现方式">
                <template  slot-scope="scope">
                    {{scope.row.type == 0 ? '微信':scope.row.type == 1 ? '支付宝' :'余额'}}
                </template>
            </el-table-column>
            <el-table-column label="提现信息" align="center">
                 <template  slot-scope="scope">
                    <div v-if="scope.row.type != 2">{{scope.row.real_name}}</div>
                    <div v-if="scope.row.type == 2">{{scope.row.bank_name}}</div>
                    <div v-if="scope.row.type != 0">{{scope.row.account}}</div>
                </template>
            </el-table-column>
            <el-table-column prop="amount" label="提现金额" align="center"></el-table-column>
            <el-table-column prop="procedure" label="手续费" align="center"></el-table-column>
            <el-table-column prop="real_price" label="到账金额" align="center"></el-table-column>
            <el-table-column prop="create_date" label="申请时间" align="center"></el-table-column>
            <el-table-column prop="update_time" label="审核时间" align="center">
                <template  slot-scope="scope">
                    {{scope.row.status == 0 ? '':scope.row.update_time}}
                </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" align="center">
                <template  slot-scope="scope">
                    {{scope.row.status == 0 ? '未审核':scope.row.status == 1 ? '提现完成' :'拒绝提现'}}
                </template>
            </el-table-column>
        </el-table>
        <el-dialog
            title="填写理由"
            :visible.sync="centerDialogVisible"
            width="30%"
            center>
            <div style="margin:auto;text-align:center">
                <span>{{aditData.status == 1?'同意理由':'拒绝理由'}}</span>
                <el-input v-model="aditData.remark" style="width:300px;margin-left:10px"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="centerDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {getWithdrawalList ,aditWithdrawal} from '../../service/distribution'
import qs from 'qs'
import VueUeditorWrap from 'vue-ueditor-wrap'
export default {
    name: 'withdrawalList',
    components: { VueUeditorWrap  },
    data() {
      return {
        aditData:{},
        tableData:[],
        search:"",
        centerDialogVisible:false
      }
    },
    created(){
        this.getList()
    },
    methods:{
        getList(){
            getWithdrawalList().then(res=>{
                this.tableData = res;
            })
        },
        audit(type,data){
            this.aditData.id = data
            if(type == 'agree'){
                this.aditData.status = 1
            }else if(type == 'refuse'){
                this.aditData.status = 2
            }
            console.log("this.aditData",this.aditData);
            this.centerDialogVisible = true
        },
        submit(){
            if(this.aditData.remark == ''){
                this.$message.error('请填写理由')
                return
            }else{
                aditWithdrawal(this.aditData).then(res=>{
                    this.aditData.remark = ""
                    this.centerDialogVisible = false
                    this.getList()
                })
            }

        }
    }
  }
</script>

<style lang="scss" scoped>
.el-radio{
    font-size: 24px;
}
.withdrawalSetting{
    background-color:#fff;
    font-size:24px;
}
</style>